import { render, staticRenderFns } from "./SimulacaoEditGarantiaEdit.vue?vue&type=template&id=010f640e"
import script from "./SimulacaoEditGarantiaEdit.vue?vue&type=script&lang=js"
export * from "./SimulacaoEditGarantiaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports